import _ from 'underscore';
import { generateGuid } from '@bingads-webui-universal/primitive-utilities';
import { ActivityFactory } from './activity-factory';
import {
  IScenarioSchema, ILoggers, IActivitySchema, IScenario,
  IScenarioFactory,
  IActivity,
} from './types';

/**
 * Scenario class to create an instance of a Scenario
 */
class Scenario implements IScenario {
  id: string;

  loggers: ILoggers;

  name: string;

  parentScenario: IScenario;

  setting: any;

  value: any;

  [key: string]: any;

  constructor(
    scenarioSchema: IScenarioSchema,
    loggers: ILoggers,
    parentScenario: IScenario,
  ) {
    this.value = scenarioSchema.value;
    this.name = scenarioSchema.name;
    this.id = generateGuid();
    this.setting = scenarioSchema.setting;
    this.loggers = loggers;
    this.parentScenario = parentScenario;

    const activities = scenarioSchema.activity;
    _.each(activities, (activity: IActivitySchema) => {
      this[(typeof activity === 'string') ? activity : activity.name] = new ActivityFactory(this, activity, loggers, parentScenario);
    });
  }

  createActivity(activityName: string): IActivity {
    return new ActivityFactory(this, activityName, this.loggers, this.parentScenario).create();
  }
}

/**
 * ScenarioFactory class responsible for creating Scenario
 */
export class ScenarioFactory implements IScenarioFactory {
  loggers: ILoggers;

  scenarioSchema: IScenarioSchema;

  /**
   * @param {object} scenarioSchema - schema of scenario to be created
   * @param {object} loggers - available loggers
   */
  constructor(scenarioSchema: IScenarioSchema, loggers: ILoggers) {
    this.scenarioSchema = scenarioSchema;
    this.loggers = loggers;
  }

  create(parentScenario?: IScenario): IScenario {
    return new Scenario(this.scenarioSchema, this.loggers, parentScenario!);
  }
}
